<template>
  <div class="playerStandIn">
    <div class="content">
      <div>
        <span v-if="switchable">Switching ...</span>
        <span v-else>Abspielen leider nicht möglich.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParamSwitch',
  data () {
    return {
      switchable: true
    }
  },

  mounted() {
    if (this.$route.query && this.$route.query.cbin) {
      this.$router.push({ name: 'BobyConnect Player', params: { videoCbinId: this.$route.query.cbin } })
    }
    else if (this.$route.query && this.$route.query.vivi_id && this.$route.query.vico_id) {
     this.$router.push({ name: 'Vipo Player', params: { collectionId: this.$route.query.vico_id, videoId: this.$route.query.vivi_id } }) 
    }
    else if (this.$route.query && this.$route.query.vkey) {
      this.$router.push({ name: 'CMP Player', params: { videoKey: this.$route.query.vkey } })
    }
    else {
      this.switchable = false
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ParamSwitch.vue